export const MAP_TIPO_EVENTO_URL = {
  'FAD': '/fad',
  'FSC': '/fsc',
  'RES': '/residenziali',
};

export const getEventoPath = (tipoEvento, slug) => `${MAP_TIPO_EVENTO_URL[tipoEvento]}/${slug}/`;

export const parseQuotaPartecipazione = (quota) => parseFloat(quota.replace('€', '').replace(',', '.')) || 0;

export const isEventoGratuito = (quotaPartecipazione) => quotaPartecipazione === '0,00 €';